import React from 'react'

const SchoolIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="29"
    viewBox="0 0 340 340"
    role="img"
    aria-labelledby="schoolIconTitle"
    {...props}
  >
    <title id="schoolIconTitle">School</title>
    <path
      fill="#2D344B"
      fillRule="evenodd"
      d="M167.052 91.11V14.176h5.896V91.11h62.89v17.696h-8.844v15.73H336.07v18.678h-11.792v127.8H340v19.663H235.838v-19.662h-9.826v19.662H113.988v-19.662h-9.826v19.662H0v-19.662h15.723V143.214H4.913v-18.679h109.075v-15.73h-9.826V91.11h62.89zM34.393 151.078v39.324h29.48v-39.324h-29.48zm40.29 0v39.324h29.479v-39.324h-29.48zm40.288 0v39.324h29.48v-39.324h-29.48zm40.29 0v39.324h29.479v-39.324h-29.48zm-25.55 58.986v58.985h34.393v-58.985h-34.393zm46.185 0v58.985h34.393v-58.985h-34.393zm19.653-58.986v39.324h29.48v-39.324h-29.48zm40.29 0v39.324h29.479v-39.324h-29.48zm40.288 0v39.324h29.48v-39.324h-29.48zM34.393 210.064v39.323h29.48v-39.323h-29.48zm40.29 0v39.323h29.479v-39.323h-29.48zm161.155 0v39.323h29.48v-39.323h-29.48zm40.29 0v39.323h29.479v-39.323h-29.48zm-171.966 90.443h131.676v9.831H104.162v-9.83zm-9.827 19.662h151.33V330H94.335v-9.83zm81.561-305.095c10.471-9.19 27.367-6.476 34.347-1.519 6.981 4.958 13.874 5.439 25.595 2.502v33.425c-7.904 6.886-24.613 9.737-33.32 2.997-8.708-6.74-15.038-6.876-26.622-2.997 0-8.096.05-30.091 0-34.408z"
      opacity=".6"
    />
  </svg>
)

export default SchoolIcon



// WEBPACK FOOTER //
// ./src/shared/components/icons/SchoolIcon.js